import { Env } from '@stencil/core';
const hostname:string = globalThis.location?.hostname?.toLowerCase();
const baseUrlParts = hostname.split('.');
const hasSubdomain = hostname.split('.').length > 2;
const baseUrlSubdomain = hasSubdomain ? baseUrlParts[0].toLowerCase() : 'www';
let envConfig = Env.apiEnv || 'prod';
let githubBranch = 'main';

if (baseUrlParts[0].toLowerCase() === 'www'){
  envConfig = 'prod';
}

const isLocalHost = baseUrlParts[0].toLowerCase() === 'localhost' || envConfig.toLowerCase() === 'local';
let isATC = baseUrlParts.includes('autotrader');
let ATC_BASE_URL = envConfig === 'prod' ? 'https://www.autotrader.com' : 'https://test.autotrader.com';
let KBB_BASE_URL = envConfig === 'prod' ? 'https://www.kbb.com' : 'https://staging.kbb.com';
const CONSUMER_API_PATH: string = '/account-api/consumer';
let API_BASE_URL = `${ATC_BASE_URL}/marketplace`;
// API_BASE_URL = `https://use1-psx-user-app-pii.awscmsprivatesellernp.autotrader.com`;

if (hostname === 'static.kbb.com') {
  envConfig = isLocalHost ? 'local' : baseUrlSubdomain === 'www' ? 'prod' : 'nonprod';
  const staticUrlParts = location.pathname.toLowerCase().split('/');
  let pathConfig = 'prod';

  if (staticUrlParts.includes('nonprod')) {
    pathConfig = 'nonprod';
    const useOwnEnvironment = false;
    if (useOwnEnvironment && staticUrlParts.includes('psx-user-web')) {
      var nonProdIndexInSplitString = staticUrlParts.indexOf('nonprod');
      githubBranch = staticUrlParts[nonProdIndexInSplitString - 1];
      API_BASE_URL = `https://use1-psx-user-app-${githubBranch}.awscmsprivatesellernp.autotrader.com`;
    }
  }

  envConfig = pathConfig ? pathConfig.toLowerCase() : envConfig;
}

const consumerConfigs = {
  nonprod: {
    Auth: {
      region: "us-east-1",
      userPoolId: "us-east-1_hUunAVTyM",
      userPoolWebClientId: "",
      userPoolWebClientIdOpts: {
        atc: "1i790ldmp9rp8oi951nqlf8rrq",
        kbb: "q4u1o2h5f8eltsge966g3mn8o",
      },
      oauth: {
        domain: "test-auth.kbb-autotrader.com",
        redirectSignIn: "https://test.autotrader.com",
        redirectSignOut: "https://test.autotrader.com",
        responseType: "code",
      },
    },
    apiKey: "DqSk2wp7eO7vj81zBU1NG2mK7riJlzIv8qQQdj1a",
  },
  prod: {
    Auth: {
      region: "us-east-1",
      userPoolId: "us-east-1_ajilIwpz2",
      userPoolWebClientId: "",
      userPoolWebClientIdOpts: {
        atc: "4ld47ibr38nvrk1lg0ducu5npn",
        kbb: "46u8n0cjg7vd04uu91a8ubjao4",
      },
      oauth: {
        domain: "auth.kbb-autotrader.com",
        redirectSignIn: "https://www.autotrader.com",
        redirectSignOut: "https://www.autotrader.com",
        responseType: "code",
      },
    },
    apiKey: "xf75twokXo6GMt99pkZNu4wF0XzjqWnj9TSQl9sU",
  },
};

const config = {
  local: {
    atcBaseUrl: ATC_BASE_URL,
    kbbBaseUrl: KBB_BASE_URL,
    apiBaseUrl: API_BASE_URL,
    isProd: false,
    enableFastFollowers: true,
    enableADIFeature: false,
    consumerApikey: consumerConfigs["nonprod"],
    consumerApiUrl: isATC ? ATC_BASE_URL + CONSUMER_API_PATH : KBB_BASE_URL + CONSUMER_API_PATH,
    branch: githubBranch,
  },
  nonprod: {
    atcBaseUrl: ATC_BASE_URL,
    kbbBaseUrl: KBB_BASE_URL,
    apiBaseUrl: API_BASE_URL,
    isProd: false,
    enableFastFollowers: true,
    enableADIFeature: false,
    consumerApikey: consumerConfigs["nonprod"],
    consumerApiUrl: isATC ? ATC_BASE_URL + CONSUMER_API_PATH : KBB_BASE_URL + CONSUMER_API_PATH,
    branch: githubBranch,
  },
  prod: {
    atcBaseUrl: ATC_BASE_URL,
    kbbBaseUrl: KBB_BASE_URL,
    apiBaseUrl: API_BASE_URL,
    isProd: true,
    enableFastFollowers: false,
    enableADIFeature: false,
    consumerApikey: consumerConfigs["prod"],
    consumerApiUrl: isATC ? ATC_BASE_URL + CONSUMER_API_PATH : KBB_BASE_URL + CONSUMER_API_PATH,
    branch: githubBranch,
  },
};

export const { isProd, atcBaseUrl, kbbBaseUrl, apiBaseUrl, atcBaseApiUrl, enableFastFollowers, enableADIFeature, consumerApikey, consumerApiUrl, branch } = config[envConfig];
